import React from "react";
import { AuthMenuItemProps } from "./types";
import { Link } from "react-router-dom";
import { ListItemGraphic, ListItemText } from "@material/react-list";
import MaterialIcon from "@material/react-material-icon";

export const AuthMenuItem: React.FC<AuthMenuItemProps> = (props) => {
  const { isVisible, route, icon, title, onClick, search, compact, closeNav } =
    props;

  const actualOnClick = onClick
    ? () => {
        onClick();
        closeNav();
      }
    : closeNav;

  if (!isVisible) {
    return null;
  }

  const linkPath = route?.path ? route.path + `${search ?? ""}` : "";

  return (
    <li>
      <Link to={linkPath} className="mdc-list-item" onClick={actualOnClick}>
        {!compact && <ListItemGraphic graphic={<MaterialIcon icon={icon} />} />}
        <ListItemText primaryText={title} />
      </Link>
    </li>
  );
};
